import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetContractorEmployeeAccessLogDetailById } from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { errorMsg } from '../../../../Apis/functions';
import { permissionObj } from '../../../../Helpers/permission';

/**
 * @component CheckInLogModalApp
 * @description Loads the detail of the contractor employee entry selected in the table.
 *
 * The row already carries most of the data, but the detail adds the selfie of the employee and the
 * materials that came in with them, with their images, so the modal is filled from the endpoint
 * instead of from the row.
 *
 * @param {Object} itemSelected - Row selected in the table, its id is the equipment access log id.
 * @returns {Object} The loaded detail and whether the exit can be registered from here.
 */
const CheckInLogModalApp = ({ itemSelected }) => {
    const dispatch = useDispatch();
    const [detail, setDetail] = useState(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    // Same write as the one of the table, the detail itself is read only
    const canCheckOut = DEV || permission?.includes(permissionObj?.WEB_UNREGISTERED_EXITS_UPDATE);

    useEffect(() => {
        if (itemSelected?.id) {
            getDetail();
        }
    }, [itemSelected?.id]);

    const getDetail = () => {
        dispatch(GetContractorEmployeeAccessLogDetailById(itemSelected?.id)).then(
            ({
                payload: {
                    data: { data, success, code },
                },
            }) => {
                if (success) {
                    setDetail(data);
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    return {
        detail,
        canCheckOut,
    };
};

export default CheckInLogModalApp;
